module.exports = __webpack_public_path__ + "static/media/presentation-minus.7decfe0d.svg";